module.exports = __webpack_public_path__ + "static/media/music-musician-musical-instrument-guitar-15919.556108ce.jpg";